//LastModifier
//***********************************************************************************************************************
import * as React from "react";
import { FormGroup } from "./formGroup";

export interface IFormRowProp {
    changeButton?: React.ReactNode;
    label?: string;
    required?: boolean;
    white?: boolean;
    width?: number;
}

export const FormRow = (props: React.PropsWithChildren<IFormRowProp>) => {
    return (
        <div className="row">
            <div className={"col-" + (props.width ?? 12).toString(10)}>
                <FormGroup
                    changeButton={props.changeButton}
                    label={props.label}
                    required={props.required}
                    white={props.white}
                >
                    {props.children}
                </FormGroup>
            </div>
        </div>
    );
};
